export default "__VITE_ASSET__9c155ee7__"